module.exports = __webpack_public_path__ + "static/media/paris-champs-elysees.d3dad9e7.jpg";